import React from "react";
import { Alert } from "antd";

const HolidayNotice = () => {
    const currentDate = new Date();
    const endDate = new Date("2026-03-23");

    if (currentDate > endDate) {
        return null;
    }

    return (
        <Alert
            message="Holiday Notice"
            description="The team will be away from 19 March - 20 March 2026 for the Eid'l Fitr holiday. We will respond to your enquiry when we are back on 23 March 2026. Sorry for the inconvenience and thank you for your understanding."
            type="info"
        />
    );
};

export default HolidayNotice;
